import QuestionInteractionBox from './QuestionInteractionBox/QuestionInteractionBox';
import { StyledQuestionInteractionBubbleTexts } from './QuestionInteractionBubble/QuestionInteraction.styled';
import QuestionInteractionBubble from './QuestionInteractionBubble/QuestionInteractionBubble';
import useQuestionInteraction from './useQuestionInteraction.hook';

export default function QuestionInteractions({
  interaction,
  playerState,
  playerActions,
  detectedCues,
  pages,
}) {
  const { state, actions } = useQuestionInteraction({
    interaction,
    playerState,
    playerActions,
    detectedCues,
    pages,
  });

  const { boxIds } = interaction.conf;
  return (
    <>
      <div className="play-mode-page">
        <div
          className="masked-boxes"
          style={
            playerState.imgPixelSize && {
              height: `${playerState.imgPixelSize.height}px`,
            }
          }
        >
          {playerState.currentPage?.boxes
            .filter(
              (box) =>
                boxIds.includes(box.id) &&
                state.interactionActive &&
                (playerState.readMode ||
                  playerState.currentCue?.boxId >= box.id)
            )
            .map((box) => {
              const animated = box.bubbles.every((bubble) => bubble.hidden);
              const centerPoint = animated
                ? calculatePolygonCenter(box.points)
                : [50, 50];
              return (
                <QuestionInteractionBox
                  className={animated ? 'animated' : ''}
                  box={box}
                  src={playerState.currentPage?.src}
                  imgNaturalSize={playerState.imgNaturalSize}
                  key={box.id}
                  centerPoint={centerPoint}
                />
              );
            })}
        </div>
      </div>
      {state.interactionActive &&
        playerState.bubbleCues &&
        playerState.imgNaturalSize && (
          <StyledQuestionInteractionBubbleTexts
            className="bubbles-texts interactions"
            style={
              playerState.imgPixelSize && {
                height: `${playerState.imgPixelSize.height}px`,
              }
            }
          >
            {playerState.bubbleCues
              .filter(
                (cue) =>
                  cue.pageId == playerState.currentPage.id &&
                  boxIds.includes(cue.boxId) &&
                  (playerState.readMode ||
                    playerState.currentCue?.boxId >= cue.boxId)
              )
              .map((cue) => {
                const box = pages[cue.pageId].boxes[cue.boxId];
                const bubble = box.bubbles[cue.bubbleId];

                const bubbleEnabled = state.interactionActive;
                const points = bubble.hidden
                  ? calculateBoundingBox(box.points)
                  : bubble.points;
                return bubbleEnabled ? (
                  <QuestionInteractionBubble
                    key={cue.id}
                    onClick={() => actions.onOptionClick(cue.boxId)}
                    bubble={{
                      ...bubble,
                      points,
                    }}
                  />
                ) : null;
              })}
          </StyledQuestionInteractionBubbleTexts>
        )}
    </>
  );
}

function calculatePolygonCenter(points) {
  let x = 0;
  let y = 0;

  points.forEach((point) => {
    x += point[0];
    y += point[1];
  });

  const center = [x / points.length, y / points.length];
  return center;
}

function calculateBoundingBox(points) {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  points.forEach((point) => {
    minX = Math.min(minX, point[0]);
    minY = Math.min(minY, point[1]);
    maxX = Math.max(maxX, point[0]);
    maxY = Math.max(maxY, point[1]);
  });

  const rectangle = [
    [minX, minY],
    [maxX, minY],
    [maxX, maxY],
    [minX, maxY],
    [minX, minY],
  ];

  return rectangle;
}
